import type { RefObject } from 'react';

import { EmptySearch } from '../../../../fixtures/timezoneSelect/components/EmptySearch/EmptySearch';
import { DropdownItem } from '../../DropdownItem/DropdownItem';
import { ScrollerDropdown } from '../../ScrollerDropdown/ScrollerDropdown';
import { TextWithHighlightedSearch } from '../TextWithHighlightedSearch/TextWithHighlightedSearch';

interface SearchBarDropdownProps<T> {
  anchorRef: RefObject<HTMLElement | null>;
  opened?: boolean;
  options: T[];
  getOptionLabel: (option: T) => string;
  getOptionKey?: (option: T) => string | number;
  onChange: (value: T) => void;
  onClickOutside?: () => void;
  search: string;
  dataTestId?: string;
}

export function SearchBarDropdown<T>({
  anchorRef,
  options,
  onChange,
  getOptionLabel,
  getOptionKey,
  search,
  opened = false,
  onClickOutside,
  dataTestId,
}: SearchBarDropdownProps<T>) {
  return (
    <ScrollerDropdown anchorRef={anchorRef} showed={opened} onClickOutside={onClickOutside} dataTestId={dataTestId}>
      {options.length === 0 ? (
        <EmptySearch />
      ) : (
        options.map(option => {
          const label = getOptionLabel(option);
          const key = getOptionKey ? getOptionKey(option) : label;
          return (
            <DropdownItem key={key} onClick={() => onChange(option)}>
              <TextWithHighlightedSearch label={label} search={search} />
            </DropdownItem>
          );
        })
      )}
    </ScrollerDropdown>
  );
}
